import gql from 'graphql-tag'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'
import { famRecipe } from '../../../fragments/RecipeFragment'
import { PaginatorInfoFragment } from '../../../fragments/PaginatorInfoFragment'

const query = gql`
  query findReplacement(
    $id: ID!
    $page: Int
    $first: Int!
    $recipeMainComponent: Boolean
  ) {
    findReplacement(
      recipe: $id
      page: $page
      first: $first
      use_same_main_component: $recipeMainComponent
    ) {
      data {
        ...famRecipe
      }
      paginatorInfo {
        ...PaginatorInfoFragment
      }
    }
  }
  ${famRecipe}
  ${PaginatorInfoFragment}
`

const transformer = ({ findReplacement }: any): any => findReplacement

type variables = {
  id: string
  page: number
  first: number
  recipeMainComponent?: boolean
}

export default queryServiceCreator<variables>(query, transformer)
